import { Alert } from '../functions'
import intlTelInput from 'intl-tel-input'
import { fr } from 'intl-tel-input/i18n'

document.addEventListener('DOMContentLoaded', function (e) {
  const object = vnObject

  const form = e.target.querySelector('.contact-form')

  if (form) {
    const phoneNumber = form.querySelector('#tel')
    if (phoneNumber) {
      intlTelInput(phoneNumber, {
        i18n: fr,
        initialCountry: 'fr',
        loadUtils: 'node_modules/intl-tel-input/build/js/build/utils.js',
      })
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault()
      e.stopPropagation()

      if (phoneNumber.value === '') {
        form.querySelector('.iti').classList.add('is-invalid')
      } else {
        form.querySelector('.iti').classList.remove('is-invalid')
      }

      if (form.checkValidity()) {
        const formData = new FormData(form)
        formData.append('action', 'vn_contact')

        const options = {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        }

        fetch(object.ajaxUrl, options)
          .then((response) => response.json())
          .then((res) => {
            form.classList.remove('sending')

            if (res.success && res.data.redirect) {
              window.location = res.data.redirect
            }

            Alert(res.success, res.data.message)

            if (res.success) {
              form.reset()
            }
          })
          .catch((error) => {
            form.classList.remove('sending')
            console.error('Erreur:', error)
          })

        form.classList.add('sending')
        Alert(false, object.formWait)
      } else {
        window.scrollTo(0, 0)
        form.classList.add('was-validated')
      }
    })
  }
})
